// extracted by mini-css-extract-plugin
module.exports = {"blog":"BlogGrid_blog__2vtye","thumb":"BlogGrid_thumb__34y9l","content":"BlogGrid_content__33piD","readmoreBtn":"BlogGrid_readmoreBtn__flhXA"};